import React from 'react';
import { HeroSectionV5 } from '../components/HeroSectionV5';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPageV5() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900 pt-[64px] md:pt-[60px]" data-id="element-805">
      <HeroSectionV5 data-id="element-806" />
      <PainSection data-id="element-807" />
      <TruthSection data-id="element-808" />
      <ProductPresentation data-id="element-809" />
      <ContentBreakdown data-id="element-810" />
      <BenefitsSection data-id="element-811" />
      <TestimonialsSection data-id="element-812" />
      <ForYouSection data-id="element-813" />
      <GuaranteeSection data-id="element-814" />
      <BonusSection data-id="element-815" />
      <ValueStack basePrice={19999} popupStrikethroughPrice="$38.997 ARS" popupSpecialPrice="$29.498 ARS" showFlashBonus={false} data-id="element-816" />
      <FAQSection data-id="element-817" />
      <ImpactPhrases data-id="element-818" />
      <Footer data-id="element-819" />
    </div>;
}